import createTitanClient, { type TitanClient } from '@narvar/titan-client';
import { getRetailerFromUrl } from './getRetailerFromUrl';
import type { WorkflowEvents } from '../workflow';

export const sourceWriteKey = getRetailerFromUrl();

export const titanClient = sourceWriteKey
  ? createTitanClient({
      url: import.meta.env.VITE_TITAN_URL,
      sourceWriteKey,
    })
  : null;

export type TitanEventType = Parameters<TitanClient['track']>[0]['event'];

export const logToTitan = ({
  event,
  properties,
}: Pick<Parameters<TitanClient['track']>[0], 'event' | 'properties'>) =>
  titanClient?.track({
    event,
    retailer_moniker: sourceWriteKey,
    channel: 'web',
    type: 'track',
    context: {
      app: {
        name: 'pdx',
      },
    },
    properties,
  });

export const workflowToTitanEvent: Partial<
  Record<WorkflowEvents['type'], TitanEventType>
> = {
  'xstate.init': 'checkout_started',
  'xstate.done.actor.getOrder': 'checkout_step_viewed',
  'xstate.done.actor.getServerState': 'checkout_step_viewed',
  updateAuthStatus: 'checkout_step_viewed',
  next: 'checkout_step_viewed',
  prev: 'checkout_step_viewed',
  goTo: 'checkout_step_viewed',
  complete: 'checkout_step_completed',
};
